import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import Index from 'components/index';
import Header from "components/header";
// import CasHeader from "components/casHeader";
// import CCNLHeader from "components/ccnlHeader";
import Footer from "components/footer";
import RequireAuth from "components/requireAuth";
import CMSSection from "components/cms/cmsSection";
import CMSInfo from "components/cms/cmsInfoDetail";
import InternalList from "components/internal/internalList";
import Login from "components/login";
import AminLogin from "components/adminLogin";
// import ReactMap from "./map";
import Iframe from "components/iframe";
import ScrollToTop from "components/ScrollToTop";
import BackTop from "antd/lib/back-top";
import {
  BASE_LINK,
  SERVICE_LINK,
  CMSINDEX_LINK,
  CMSSECTION_LINK,
  CMSINFO_LINK,
  MY_LINK,
  IFRAME_LINK,
  LOGIN_LINK,
  ADMIN_LOGIN_LINK,
  DASHBOARD_LINK,
  ADMIN_INDEX_LINK,
  ADMIN_INDEX_CONFIG_LINK,
  TODO_LINK,
  // MAP_LINK,
  INTERNAL_LIST_LINK
} from "../actions/types";
import loading from "images/oval.svg";
import Loadable from "react-loadable";
const Loading = props => {
  if (props.error) {
    console.log(props.error);
    return (
      <div>
        Error! <button onClick={props.retry}>Retry</button>
      </div>
    );
  } else if (props.timedOut) {
    return (
      <div>
        Taking a long time... <button onClick={props.retry}>Retry</button>
      </div>
    );
  } else if (props.pastDelay) {
    return <div style={{ textAlign: "center" }}>Loading...</div>;
  } else {
    return null;
  }
};

const dashBoard = Loadable({
  loader: () => import("components/dashBoard/dashBoard.js"),
  loading: Loading
});
const ServiceSection = Loadable({
  loader: () => import("components/service/service"),
  loading: Loading
});
const CMSIndex = Loadable({
  loader: () => import("components/cms/cmsIndex"),
  loading: Loading
});
const PersonalIndex = Loadable({
  loader: () => import("components/personal/personalIndex"),
  loading: Loading
});
const TodoIndex = Loadable({
  loader: () => import("components/todoIndex"),
  loading: Loading
});
const AdminIndex = Loadable({
  loader: () => import("components/admin/adminIndex"),
  loading: Loading
});
const AdminIndexConfig = Loadable({
  loader: () => import("components/admin/adminInterfaceNew"),
  loading: Loading
});

class App extends Component {
  componentDidMount() {
    if (
      navigator.userAgent.indexOf("iPhone") > -1 ||
      navigator.userAgent.indexOf("Android") > -1
    ) {
      if (!(window.location.pathname.indexOf("/m") > -1)) {
        let url = "/m" + window.location.pathname;
        window.location.assign(url);
      }
    }
  }
  render() {
    // console.log(process.env);
    return (
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ScrollToTop>
          <Header />
          <div className="App">
            <Switch>
              {/* <Route path={MAP_LINK} component={ReactMap} /> */}
              <Route path={DASHBOARD_LINK} component={RequireAuth(dashBoard)} />
              <Route
                path={SERVICE_LINK}
                component={RequireAuth(ServiceSection)}
              />
              <Route path={MY_LINK} component={RequireAuth(PersonalIndex)} />
              <Route path={CMSINDEX_LINK} component={RequireAuth(CMSIndex)} />
              <Route path={TODO_LINK} component={RequireAuth(TodoIndex)} />
              <Route path={`${CMSSECTION_LINK}=:link`} component={CMSSection} />
              <Route
                path={`${CMSINFO_LINK}=:link`}
                component={RequireAuth(CMSInfo)}
              />
              <Route path={`${IFRAME_LINK}=:link`} component={Iframe} />
              <Route
                path={`${INTERNAL_LIST_LINK}/:internalName`}
                component={RequireAuth(InternalList)}
              />
              <Route
                path={ADMIN_INDEX_LINK}
                component={RequireAuth(AdminIndex)}
              />
              <Route
                path={ADMIN_INDEX_CONFIG_LINK}
                component={RequireAuth(AdminIndexConfig)}
              />
              {/* <Route path={SIGNUP_LINK} component={Register} /> */}
              <Route path={ADMIN_LOGIN_LINK} component={AminLogin} />
              <Route path={LOGIN_LINK} component={Login} />
              <Route path={BASE_LINK} component={Login} />
            </Switch>
            <BackTop visibilityHeight="200" />
          </div>
          <Footer />
          <div className="loading">
            <img src={loading} alt="loading" />
          </div>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}
export default connect(null)(App);
// export default App;
